import { FC } from 'react';
import AnalyticsExportPageFrame, {
  type AnalyticsExportPageProfile,
} from './AnalyticsExportPageFrame';
import { useAnalyticsExportTheme } from './analyticsExportTheme';

export interface AnalyticsExportPostCard {
  key: string;
  imageUrl: string | null;
  formatLabel: string;
  headlineValue: string;
  caption: string;
  metricsLine: string;
}

interface Props {
  title: string;
  subtitle: string;
  posts: AnalyticsExportPostCard[];
  profile: AnalyticsExportPageProfile;
  pageNumber: number;
  totalPages: number;
}

const AnalyticsExportPostsPage: FC<Props> = ({
  title,
  subtitle,
  posts,
  profile,
  pageNumber,
  totalPages,
}) => {
  const theme = useAnalyticsExportTheme();

  return (
    <AnalyticsExportPageFrame
      title={title}
      subtitle={subtitle}
      profile={profile}
      pageNumber={pageNumber}
      totalPages={totalPages}
      dataCy="analytics_export-public_posts-page"
    >
      <div className="tw-flex tw-flex-1 tw-content-start tw-gap-6 tw-py-8">
        {posts.map((post) => (
          <div
            key={post.key}
            className="analytics-export-post-card tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-3 tw-self-start"
          >
            <div
              className={`analytics-export-post-card-media tw-relative tw-w-full tw-overflow-hidden tw-rounded-2xl ${theme.mediaPlaceholder}`}
            >
              {post.imageUrl ? (
                <img
                  src={post.imageUrl}
                  alt=""
                  className="tw-h-full tw-w-full tw-object-cover"
                />
              ) : null}
              <div className="tw-absolute tw-bottom-3 tw-left-3 tw-flex tw-items-center tw-gap-2">
                <span className="tw-rounded-full tw-bg-white tw-px-3 tw-py-1 tw-text-base tw-font-semibold tw-text-grayscale-190">
                  {post.headlineValue}
                </span>
                <span className="tw-rounded-full tw-bg-white tw-px-3 tw-py-1 tw-text-base tw-font-semibold tw-text-grayscale-190">
                  {post.formatLabel}
                </span>
              </div>
            </div>
            <div
              className={`${theme.tile} tw-flex tw-flex-col tw-gap-2 tw-rounded-2xl tw-px-5 tw-py-4`}
            >
              <p
                className={`analytics-export-post-card-caption tw-text-base ${theme.tileValue}`}
              >
                {post.caption}
              </p>
              <p className={`${theme.accent} tw-text-sm tw-font-medium`}>
                {post.metricsLine}
              </p>
            </div>
          </div>
        ))}
      </div>
    </AnalyticsExportPageFrame>
  );
};

export default AnalyticsExportPostsPage;
